import { Route } from '@angular/router';
import { portalProveedoresPersonalizeGuard } from './pages/login/portal-proveedores-personalize.session';

export const appRoutes: Route[] = [
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () =>
      import(
        './pages/landing/portal-proveedores-landing-page.component'
      ).then((m) => m.PortalProveedoresLandingPageComponent),
  },
  {
    path: 'login',
    loadComponent: () =>
      import(
        './pages/login/portal-proveedores-login-page.component'
      ).then((m) => m.PortalProveedoresLoginPageComponent),
  },
  {
    path: 'personalize-password',
    canActivate: [portalProveedoresPersonalizeGuard],
    loadComponent: () =>
      import(
        './pages/login/portal-proveedores-login-page.component'
      ).then((m) => m.PortalProveedoresLoginPageComponent),
  },
  {
    path: 'recover-password',
    loadComponent: () =>
      import(
        './pages/login/portal-proveedores-login-page.component'
      ).then((m) => m.PortalProveedoresLoginPageComponent),
  },
  {
    path: 'register',
    loadComponent: () =>
      import(
        './pages/register/portal-proveedores-register-page.component'
      ).then((m) => m.PortalProveedoresRegisterPageComponent),
  },
  {
    path: 'register-status/consulta',
    pathMatch: 'full',
    redirectTo: 'register-status/consulta/general-information',
  },
  {
    path: 'register-status/consulta/:section',
    loadComponent: () =>
      import(
        './pages/register-status/portal-proveedores-register-consultation-page.component'
      ).then((m) => m.PortalProveedoresRegisterConsultationPageComponent),
  },
  {
    path: 'register-status',
    loadComponent: () =>
      import(
        './pages/register-status/portal-proveedores-register-status-page.component'
      ).then((m) => m.PortalProveedoresRegisterStatusPageComponent),
  },
  {
    path: 'home',
    loadComponent: () =>
      import(
        './pages/home/portal-proveedores-home-page.component'
      ).then((m) => m.PortalProveedoresHomePageComponent),
  },
];
